/**
 * API для WABA templates в чате (TODO-027a)
 * Дата: 15.01.2026
 *
 * СВЯЗАННЫЕ МОДУЛИ И ФАЙЛЫ:
 * - `frontend/src/hooks/useWABATemplates.ts` — использует list templates
 * - `frontend/src/components/features/messages/WABATemplateForm.tsx` — вызывает sendTemplate
 * - `frontend/src/components/features/messages/WindowStatusIndicator.tsx` — вызывает getWindowStatus
 * - Backend:
 *   - `GET /api/templates/waba`
 *   - `POST /api/messages/send-template`
 *   - `GET /api/conversations/window-status`
 *
 * СХЕМА:
 * - Композиция функций:
 *   - wabaApi.getTemplates -> GET /templates/waba
 *   - wabaApi.sendTemplate -> POST /messages/send-template
 *   - wabaApi.getWindowStatus -> GET /conversations/window-status
 */
import { apiClient } from './client';
import type { WABATemplate } from './templates';

export interface SendWABATemplateRequest {
  tenant_id?: string;
  phone: string;
  template_guid: string;
  template_name?: string;
  variables: Record<string, string>;
}

export interface WABAWindowStatusResponse {
  phone: string;
  window_open: boolean;
  requires_template?: boolean;
  window_expires_at?: string;
  last_incoming_at?: string;
}

export const wabaApi = {
  getTemplates: async (tenantId?: string): Promise<{ templates: WABATemplate[] }> => {
    const params: Record<string, string> = {};
    if (tenantId) params.tenant_id = tenantId;
    const res = await apiClient.get('/templates/waba', { params });
    return res.data;
  },

  sendTemplate: async (data: SendWABATemplateRequest) => {
    const params: Record<string, string> = {};
    if (data.tenant_id) params.tenant_id = data.tenant_id;
    const res = await apiClient.post('/messages/send-template', data, { params });
    return res.data;
  },

  getWindowStatus: async (tenantId: string | undefined, phone: string): Promise<WABAWindowStatusResponse> => {
    const params: Record<string, string> = { phone };
    if (tenantId) params.tenant_id = tenantId;
    const res = await apiClient.get('/conversations/window-status', { params });
    return res.data;
  },
};

